import { render, staticRenderFns } from "./common-intents-form.vue?vue&type=template&id=01dfa0ec"
import script from "./common-intents-form.ts?vue&type=script&lang=ts&external"
export * from "./common-intents-form.ts?vue&type=script&lang=ts&external"
import style0 from "./common-intents-form.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports